import { render } from "./ReferenceReportParametres.vue?vue&type=template&id=f608bf88"
import script from "./ReferenceReportParametres.vue?vue&type=script&lang=js"
export * from "./ReferenceReportParametres.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__